import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, Trash } from '@phosphor-icons/react';

import { IExtractorVendorMapping } from 'companySettings/types';
import { Color, Direction, Level } from 'theme/enums';

import { RemoveExtractorVendorMappingsButton } from '../RemoveExtractorVendorMappingsButton';
import { UpsertExtractorVendorMappingButton } from '../UpsertExtractorVendorMapping';

interface IProps {
  data?: IExtractorVendorMapping;
  canEdit?: boolean;
  canRemove?: boolean;
}

export const ActionsCell = ({ data, canEdit = false, canRemove = false }: IProps) => {
  if (!data) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} sx={{ alignItems: 'center', gap: 1 }}>
      {canEdit && (
        <UpsertExtractorVendorMappingButton
          extractorVendorMapping={data}
          buttonElement={
            <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
              <PencilSimpleLine />
            </Typography>
          }
        />
      )}

      {canRemove && (
        <RemoveExtractorVendorMappingsButton
          extractorVendorMappings={[data]}
          buttonElement={
            <Typography color={Color.DANGER} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
              <Trash />
            </Typography>
          }
        />
      )}
    </Stack>
  );
};
